export default __webpack_public_path__ + "static/media/menu-lateral.27758cd0.svg";